import React from "react";
import "./hotsiteHeader.css";
import { trans } from "sharedKernel/i18n";
import { Logo, LinksWrapper, LoginLink, HeaderLink } from "./styles";
import { BaseButton } from "iebt-zing-storybook";
import { Container, Navbar, Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSmartNavigateLegacy as useNavigate } from "components/SmartLink";
import { ROUTES } from "sharedKernel/constants";
import { ESPACO_TEIA_LOGO_URL } from "components/branding/espacoTeiaBranding.styles";

type HotsiteHeaderProps = {
  logoHref?: string
}

export const HotsiteHeader = ({ logoHref = '/' }: HotsiteHeaderProps): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const labels = {
    open_challenges: trans("Programas de Inovação"),
    open_events: trans("Eventos"),
    contact: trans("Contato"),
    login: trans("Acessar conta"),
    demo: trans("Solicitar Demonstração"),
  };

  const queryParams = new URLSearchParams(location.search);
  const challengeId = queryParams.get("challengeId");

  const handleLoginClick = () => {
    if (challengeId) {
      localStorage.setItem("redirectChallengeId", challengeId);
    }
    navigate(ROUTES.USER_AUTH.LOGIN, { state: { hotsite: true } });
  };

  return (
    <Navbar className="hotsite-navbar-bg shadow-sm sticky-top" expand="lg">
      <Container>
        <Navbar.Brand>
          <a href={logoHref}>
            <Logo src={ESPACO_TEIA_LOGO_URL} alt="Espaço TEIA Caixa" />
          </a>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar" />
        <Navbar.Collapse id="navbar">
          <Nav className="me-auto"></Nav>
          <LinksWrapper>
            <LoginLink onClick={handleLoginClick}>
              {labels.login}
            </LoginLink>
          </LinksWrapper>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
